var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterviews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.698 7.313H3.61401V20.122H27.698V7.313Z",
    fill: "#C8D5FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.252 5H4V18.8H28.252V5Z",
    fill: "#C8D5FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.256 15.294C19.121 15.088 18.845 15.031 18.639 15.166L17.941 15.623C17.735 15.759 17.678 16.036 17.815 16.242C17.9 16.373 18.043 16.444 18.188 16.444C18.272 16.444 18.357 16.421 18.432 16.37L19.129 15.913C19.336 15.777 19.392 15.5 19.256 15.294Z",
    fill: "#2F2B82"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53299 22C3.53299 22.11 3.62299 22.2 3.73299 22.2H27.891C28.001 22.2 28.091 22.11 28.091 22V5.42C28.091 5.31 28.001 5.22 27.891 5.22H3.73299C3.62299 5.22 3.53299 5.31 3.53299 5.42V22Z",
    stroke: "#2F2B82",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 22.025C12.339 23.477 12.106 24.885 11.703 26.225H10.062C9.763 26.225 9.521 26.494 9.521 26.824C9.521 27.156 9.763 27.426 10.062 27.426H21.67C21.969 27.426 22.211 27.156 22.211 26.824C22.211 26.494 21.969 26.225 21.67 26.225H20.028C19.626 24.885 19.392 23.477 19.332 22.025H12.4ZM18.895 26.346H12.838C13.21 25.135 13.425 23.868 13.482 22.567H18.25C18.306 23.868 18.522 25.135 18.895 26.346Z",
    fill: "#2F2B82"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.79 15.623L10.875 13.709L13.79 11.796C13.996 11.66 14.053 11.383 13.917 11.177C13.783 10.971 13.505 10.913 13.299 11.048L9.817 13.336C9.691 13.418 9.616 13.559 9.616 13.709C9.616 13.86 9.691 14 9.817 14.083L13.299 16.37C13.374 16.421 13.46 16.444 13.543 16.444C13.689 16.444 13.832 16.373 13.917 16.242C14.053 16.036 13.996 15.76 13.79 15.623Z",
    fill: "#2F2B82"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.057 9.375C16.82 9.311 16.573 9.449 16.507 9.688L14.362 17.495C14.297 17.732 14.436 17.978 14.674 18.043C14.714 18.056 14.752 18.061 14.792 18.061C14.987 18.061 15.169 17.93 15.224 17.732L17.369 9.925C17.434 9.687 17.294 9.44 17.057 9.375Z",
    fill: "#2F2B82"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.914 13.336L18.432 11.048C18.226 10.913 17.949 10.971 17.815 11.177C17.678 11.383 17.735 11.66 17.941 11.796L20.856 13.709L19.688 14.477C19.482 14.613 19.424 14.89 19.56 15.095C19.646 15.226 19.789 15.297 19.934 15.297C20.018 15.297 20.103 15.274 20.178 15.223L21.913 14.083C22.04 14 22.116 13.86 22.116 13.709C22.116 13.559 22.04 13.418 21.914 13.336Z",
    fill: "#2F2B82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviews);
export default __webpack_public_path__ + "static/media/interviews.7afa22535c64824b1279fa9257fdde8b.svg";
export { ForwardRef as ReactComponent };